<template>
  <div class="translate">
    <div class="translate-inner-wrap">
      <h1>Translate</h1>
      <div class="translate-input-wrap">
        <label>ISBN</label>
        <input class="translate-input-isbn" v-model="bookISBN" type="text">
        <label>Page Number</label>
        <input class="translate-input-page" v-model="pageNumber" type="number">
      </div>
      <div class="translate-btn-wrap">
        <button v-on:click="getWordsFromDb" class="translate-get-btn">Get book</button>
        <button class="translate-now-btn">Translate words</button>
        <button v-on:click="writeWordToFireDB" class="translate-write-btn">Write to DB</button>
        <button v-on:click="wordLookUp('lass')" class="test-btn">Multi Button</button>
      </div>
    </div>
    {{sessionDic}}
    <div class="translate-page-display">
      <div class="translate-page-raw">
        {{selectedPage}}
      </div>
      <div class="translate-page-words">
        {{wordsArray}}
      </div>
    </div>
  </div>
</template>

<script>
//Get bookpages from Firestore
//Filter words into array
//Loop through words array
    //Look up in firestore libary
    //Look up in externel API (switch between all three)
        //If gotten from here add to Firestore libary
    //Add to page-word-array (Array og objects)

import { db } from '@/firebase'
import axios from 'axios';

export default {
  data () {
    return {
      bookISBN: 'fire-2020-04-20',
      pageNumber: 0,
      selectedPage: '',
      wordsArray: [],
      pagesWordsArray: [],
      sessionDic: [
        {
          verb: true,
          queryText: "comer-",
          def1: "to eat",
          def2: null,
          verbInfo: null
        },
        {
          verb: true,
          queryText: "las-",
          def1: "the",
          def2: "them",
          verbInfo: null
        }
      ],
      nextApi: 0,
      currentWord: '',
      apiArray: [
        'https://us-central1-b-request.cloudfunctions.net/arequest/?key=SimpleProtectionKey&word=',
        'https://us-east1-b-request.cloudfunctions.net/arequestuseast/?key=SimpleProtectionKey&word=',
        'https://asia-northeast1-b-request.cloudfunctions.net/asiaNortheast/?key=SimpleProtectionKey&word='
      ]
    }
  },
  name: 'Translate',
  components: {
  },
  methods: {
    getWordsFromDb: function() {
      db.collection("books")
      .where('isbn', '==', this.bookISBN)
      .get().then((snap) => {
        let bookData = snap.docs[0].data()
        this.selectedPage = bookData.pages[this.pageNumber]
        this.filterWords()
      }).catch((error)=> {
        console.log(error)
      })
    },
    filterWords: function() {
      let parser = new DOMParser();
      const doc = parser.parseFromString(this.selectedPage, "text/html");
      const paragraphs = doc.querySelectorAll('.word-box');
      let arrayToReturn = [];
      paragraphs.forEach((userItem) => {
        arrayToReturn.push(userItem.innerHTML)
      });
      this.wordsArray = arrayToReturn
    },
    wordLookUp: async function(word) {
      let obj = this.sessionDic.find(obj => obj.queryText == word);
      if(obj) {
        console.log(obj)
        console.log('Found it in sessionDic, return and end')
        return obj
      }
      try {
        const fireDbWord = await db.collection("dictionary").where('queryText', '==', word).get()
        if(fireDbWord.docs.length > 0) {
          const wordObjFire  = fireDbWord.docs[0].data()
          const wordObj = {
            verb: wordObjFire.verb,
            queryText: wordObjFire.queryText,
            def1: wordObjFire.def1,
            def2: wordObjFire.def2,
            verbInfo: wordObjFire.verbInfo
          }
          console.log(fireDbWord.docs[0].data())
          console.log('Found it in FireDB, return and end')
          this.sessionDic.push(wordObj)
          return wordObj
        }
      } catch (error) {
        console.log('Error in getting word from FirestoreDB')
        console.log(error)
        return
      }
      try {
        const apiWordObj = await axios.get(`${this.apiArray[0]}${word}`)
        console.log(apiWordObj)

        // .then((response) => {
        //   this.wordTranslation = response.data
        //   this.$store.commit('openLookupModal')
        //   this.$store.commit('setLookupWords', {
        //     eng: this.wordSelection, 
        //     esp: this.wordTranslation
        //   })
        // })     
      } catch (error) {
        console.log('Error in getting word from axios')
        console.log(error)
      }
      console.log('Didnt find it')
      //Look word in sessionDic
      //lookup word firestore
      //Lookup word in external API (3)
      //Return word obj      
    },
    writeWordToFireDB: function() {
      db.collection("dictionary").add({
        verb: false,
        queryText: "las",
        def1: "the",
        def2: "them",
        verbInfo: null
      })
      .then(function(docRef) {
          //Set sessionDic as well
          console.log("Document written with ID: ", docRef.id);
      })
      .catch(function(error) {
          console.error("Error adding document: ", error);
      });
    }
  },
  mounted() {

  }
}
</script>

<style scoped>
  .translate {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    
  }
  .translate-inner-wrap {
    width: 500px;
  }
  .translate-input-wrap {
    margin-bottom: 20px;
  }
  .translate-input-wrap label{
    margin: 0 5px 0 15px;
  }
  .translate-input-page {
    width: 50px;
  }
  .translate-btn-wrap {
    margin-bottom: 20px;
  }
  .translate-btn-wrap button {
    margin: 0 10px;
  }
  .translate-page-display {
    display: flex;
    flex-direction: row;
    max-width: 800px;
  }
  .translate-page-words, 
  .translate-page-raw {
    width: 50%;
  }

</style>